import React, {useEffect} from 'react';
import { StaticImage } from "gatsby-plugin-image";
import { SvgIcon } from "components/ui";
import {accordion} from "@uswds/uswds/src/js/components";

const Banner = () => {


  useEffect(() => {
    // initialize
    accordion.on();
    // default ref is document.body, if you want to use
    // default you do not have to pass arguments
    accordion.on();

    // remove event listeners when the component un-mounts.
    return () => {
      accordion.off();
    };
  })
  return <div className="usa-banner">
    <div className="usa-accordion">
      <header className="usa-banner__header">
        <div className="usa-banner__inner">
          <div className="grid-col-auto">
            <StaticImage
              className="usa-banner__header-flag"
              src="../../../assets/images/us_flag_small.png"
              alt="U.S. flag"
            />
          </div>
          <div className="grid-col-fill tablet:grid-col-auto">
            <p className="usa-banner__header-text">
              An official website of the United States government
            </p>
            <p className="usa-banner__header-action" aria-hidden="true">
              Here’s how you know
            </p>
          </div>
          <button
            aria-controls="gov-banner"
            aria-expanded={false}
            className="usa-accordion__button usa-banner__button"
          >
            <span className="usa-banner__button-text">Here's how you know</span>
          </button>
        </div>
      </header>
      <div
        id="gov-banner"
        className="usa-accordion__content usa-banner__content"
        hidden
      >
        <div className="grid-row grid-gap-lg">
          <div className="usa-banner__guidance-gov tablet:grid-col-6">
            <SvgIcon name="dotgov" className="usa-banner__icon usa-media-block__img" />
            <div className="usa-media-block__body">
              <p>
                <strong>The .gov means it’s official.</strong>
                <br />
                Federal government websites often end in .gov or .mil. Before
                sharing sensitive information, make sure you’re on a federal
                government site.
              </p>
            </div>
          </div>
          <div className="usa-banner__guidance-ssl tablet:grid-col-6">
            <SvgIcon name="https" className="usa-banner__icon usa-media-block__img" alt="Https" />
            <div className="usa-media-block__body">
              <p>
                <strong>The site is secure.</strong>
                <br />
                The <strong>https://</strong> ensures that you are connecting to
                the official website and that any information you provide is
                encrypted and transmitted securely.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
};

export default Banner;
